import { render } from "./Characters.vue?vue&type=template&id=61142002"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__